import React from "react";

const FormButtonGroup = ({ clearForm }) => {
  return (
    <div style={{ paddingBottom: 10 }}>
      <div className="btn-group">
        <button type="submit" className="btn btn-primary">
          <i className="fa fa-check-circle" /> Save
        </button>
        <button type="button" className="btn btn-warning" onClick={clearForm}>
          <i className="fa fa-ban" /> Clear Form
        </button>
      </div>
    </div>
  );
};

export default FormButtonGroup;



// WEBPACK FOOTER //
// ./src/pages/ManageExhibit/FormButtonGroup.jsx